import React, { useState, useRef } from 'react';
import { useLazyQuery } from '@apollo/client';
import { MdDelete } from 'react-icons/md';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { GET_PRESIGN_URL } from '../../../graphql/presignUrl/query';

function UploadManyImages() {
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedNewImages, setSelectedNewImage] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [msgError, setMsgError] = useState(null);
    const inputRef = useRef();

    const [getPresignUrl] = useLazyQuery(GET_PRESIGN_URL);

    const handleClick = () => {
        inputRef.current.click();
    };

    const handleImageSelect = async (event) => {
        try {
            const files = event.target.files;
            if (!files) return;

            const newImages = [...selectedImages];
            const newImagesMulti = [...selectedNewImages];

            if (newImages.length + files.length > 9) {
                setMsgError("ເລືອກຮູບພາບເພີ່ມເຕີ່ມໄດ້ສູງສຸດ 9 ຮູບ");
                return;
            }

            for (let i = 0; i < files.length; i++) {
                const file = files[i];

                if (!file) return;
                const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!allowedTypes.includes(file?.type)) {
                    setMsgError(`ກະລຸນາເລືອກຮູບພາບທີ່ເປັນ ${<br></br>}png, jpg, jpge`);
                    return;
                }


                const ext = file.name.split(".").pop();
                const filename = uuidv4() + "." + ext;

                const { data } = await getPresignUrl({
                    variables: {
                        name: filename,
                    },
                });

                await uploadToS3(data.preSignedUrl.url, file);
                newImages.push(URL.createObjectURL(file));
                newImagesMulti.push(filename);
                setSelectedNewImage(newImagesMulti);
                setSelectedImages(newImages);
                setMsgError(null); // Clear the error message on successful upload

            }
        } catch (error) {
            console.log("Error uploading image:", error);
            setMsgError("Error uploading image");
        }
    };

    const uploadToS3 = async (url, file) => {
        console.log("url ::", url)
        console.log("file ::", file)
        try {
            await axios.put(url, file, {
                headers: {
                    "Content-Type": "file/*; image/*",
                },
                onUploadProgress: (progressEvent) => {
                    const progress = (progressEvent.loaded / progressEvent.total) * 100;
                    setUploadProgress(progress);
                },
            });
        } catch (error) {
            console.log("Error uploading to S3:", error);
            setMsgError("Error uploading to S3");
        }
    };

    const handleImageDelete = (index) => {
        const newImages = [...selectedImages];
        const newImageS3 = [...selectedNewImages];
        newImages.splice(index, 1);
        newImageS3.splice(index, 1);
        setSelectedImages(newImages);
        setSelectedNewImage(newImageS3);
    };

    return (
        <>
            <div className="editproductlist-left-subtitle" style={{ marginTop: 24 }}>
                <span style={{ color: "#334155" }}>ຮູບສິນຄ້າເພີ່ມເຕີ່ມ</span>
                (ສູງສຸດ {selectedImages.length}/9)
            </div>

            <div style={{ marginTop: 16 }}>
                <div>
                    <input
                        style={{ display: "none" }}
                        ref={inputRef}
                        type="file"
                        onChange={handleImageSelect}
                    />
                    <Button
                        disabled={selectedImages.length >= 9}
                        title={"ເພີ່ມຮູບປະກອບ"}
                        onClick={handleClick}
                    >
                        ເພີ່ມຮູບປະກອບ
                    </Button>
                </div>
                {msgError && (
                    <div style={{ color: 'red', marginTop: '8px' }}>
                        {msgError}
                    </div>
                )}
            </div>
            <br></br>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                {selectedImages.map((image, index) => (
                    <div key={index} style={{ position: 'relative', width: 'calc(50% - 8px)', marginBottom: '16px', border: '1px solid #E2E8F0', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 0 8px rgba(0, 0, 0, 0.1)' }}>
                        <div style={{ height: '120px', overflow: 'hidden' }}>
                            <img
                                src={image}
                                alt={`Image ${index}`}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        </div>
                        <div style={{ position: 'absolute', top: '0', right: '0', padding: '8px' }}>
                            <MdDelete
                                onClick={() => handleImageDelete(index)}
                                style={{ cursor: 'pointer', color: 'red', }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export default UploadManyImages;
